import { Decimal, type DecimalInput } from '@app/shared';
import { InputNumber } from 'antd';

export interface QtyStepperProps {
  value: string;
  onChange: (value: string) => void;
  min?: DecimalInput;
  step?: DecimalInput;
  disabled?: boolean;
  size?: 'small' | 'middle' | 'large';
}

/** Decimal-safe quantity input (min/multiple-aware) — antd `InputNumber` in `stringMode` so large
 *  or fractional quantities never round-trip through a JS float. */
export function QtyStepper({ value, onChange, min, step, disabled, size }: QtyStepperProps) {
  const minValue = new Decimal(min ?? 0).toString();
  const stepValue = new Decimal(step ?? 1).toString();

  return (
    <InputNumber<string>
      stringMode
      value={value}
      min={minValue}
      step={stepValue}
      disabled={disabled}
      size={size}
      onChange={(next) => onChange(next ?? minValue)}
      style={{ width: 100 }}
    />
  );
}
